import type { ModalComponentProps } from "@/lib/modal";
import { ConfirmationModal } from "@/components/modals/confirmation-modal";
import { useDeleteDocument, type Document } from "@/lib/api/knowledge-base";
import { truncate } from "@/lib/format";

export interface DeleteDocumentModalProps {
  applicationGuildId: string;
  document: Document;
}

export function DeleteDocumentModal({
  applicationGuildId,
  document,
  onClose,
}: DeleteDocumentModalProps & ModalComponentProps) {
  const deleteMutation = useDeleteDocument(applicationGuildId);

  const handleDelete = async () => {
    await deleteMutation.mutateAsync(document.id);
    onClose();
  };

  return (
    <ConfirmationModal
      title="Delete Document"
      description="Are you sure you want to delete this document? This action cannot be undone."
      confirmLabel="Delete"
      pendingLabel="Deleting..."
      onConfirm={handleDelete}
      isPending={deleteMutation.isPending}
      onClose={onClose}
    >
      <div className="bg-muted/50 my-4 rounded-lg border p-4">
        <p className="font-medium">{document.title || `#${document.id}`}</p>
        <p className="text-muted-foreground mt-1 text-sm">
          {truncate(document.content, 150)}
        </p>
      </div>
    </ConfirmationModal>
  );
}

DeleteDocumentModal.displayName = "DeleteDocumentModal";
